import GlobalLayerStore from 'store/GlobalLayer';
import { Channel, CouponType } from 'types/common';
import {
    setPendingSubscriptionChannel,
    setPendingSubscriptionPlan,
    setSubscriptionCallbackPath,
    setSubscriptionCallbackShowSuccess,
} from './localstore';
import SubscriptionStore from 'store/Subscription';
import { setShowKiwiPlanAdvertise } from './sessionStorage';
import { ICampaign } from 'types/campaign';

const getPath = () => {
    let path = window.location.pathname;
    if (window.location.search) {
        path += window.location.search;
    }
    return path;
};

export const openSubscriptionModal = (showSuccessModal: boolean = true, path?: string) => {
    if (showSuccessModal) {
        setSubscriptionCallbackShowSuccess(true);
    }
    setShowKiwiPlanAdvertise(false);
    const callbackPath = path || getPath();
    setSubscriptionCallbackPath(callbackPath);
    //clear channel info
    setPendingSubscriptionChannel(undefined);
    GlobalLayerStore.set('pendingSubscriptionChannel', undefined);
    GlobalLayerStore.set('showSubscriptionModal', true);
};

export const closeSubscriptionModal = () => {
    setSubscriptionCallbackShowSuccess(false);
    GlobalLayerStore.set('showSubscriptionModal', false);
};

export const openManageSubscriptionModal = (tabKey?: string) => {
    setShowKiwiPlanAdvertise(false);
    setSubscriptionCallbackShowSuccess(true);
    const params = {
        show: true,
        tabKey,
    };
    GlobalLayerStore.set('showManageSubscriptionModal', params);
};

export const closeManageSubscriptionModal = () => {
    setSubscriptionCallbackShowSuccess(false);
    const params = {
        show: false,
    };
    GlobalLayerStore.set('showManageSubscriptionModal', params);
};

export const openSubscriptionSuccessModal = () => {
    GlobalLayerStore.set('showSubscriptionSuccess', true);
};

export const closeSubscriptionSuccessModal = () => {
    GlobalLayerStore.set('showSubscriptionSuccess', false);
};

export const openSubscriptionTalkModal = () => {
    GlobalLayerStore.set('showSubscriptionTalk', true);
};

export const closeSubscriptionTalkModal = () => {
    GlobalLayerStore.set('showSubscriptionTalk', false);
};

export const openChannelSubscriptionModal = ({
    showSuccessModal = true,
    channel,
}: {
    showSuccessModal?: boolean;
    channel: Channel;
}) => {
    if (showSuccessModal) {
        setSubscriptionCallbackShowSuccess(true);
    }
    setSubscriptionCallbackPath(getPath());
    setPendingSubscriptionPlan(undefined);
    GlobalLayerStore.set('pendingSubscriptionChannel', channel);
    GlobalLayerStore.set('showChannelSubscriptionModal', true);
};

export const closeChannelSubscriptionModal = () => {
    setSubscriptionCallbackShowSuccess(false);
    GlobalLayerStore.set('showChannelSubscriptionModal', false);
};

export const enableHideOtherModalsForAgreementSignModal = () => {
    GlobalLayerStore.set('hideOtherModalsForAgreementSignModal', true);
};

export const disableHideOtherModalsForAgreementSignModal = () => {
    GlobalLayerStore.set('hideOtherModalsForAgreementSignModal', false);
};

export const openUniprofileAgreementSignModal = (title: string, loopFetch: boolean) => {
    const payPlan = SubscriptionStore.get('currentPlan');

    if (payPlan?.couponType !== CouponType.HEADWAY) {
        // 签署合同最重要，所以保证值弹它，不过目前只处理了新的onboarding 流程中的弹出框隐藏
        // 其他的modal没处理，如果有需要的话，可以加个hideOtherModalsForAgreementSignModal === true再允许弹
        enableHideOtherModalsForAgreementSignModal();
        GlobalLayerStore.set('showUniprofileAgreementSignModal', {
            show: true,
            title,
            loopFetch,
        });
    }
};

export const closeUniprofileAgreementSignModal = () => {
    disableHideOtherModalsForAgreementSignModal();
    GlobalLayerStore.set('showUniprofileAgreementSignModal', {
        show: false,
        title: '',
        loopFetch: false,
    });
};

export const openKlaritySubscriptionModal = (showSuccessModal: boolean = true, path?: string) => {
    if (showSuccessModal) {
        setSubscriptionCallbackShowSuccess(true);
    }

    const callbackPath = path || getPath();
    setSubscriptionCallbackPath(callbackPath);
    GlobalLayerStore.set('showKlaritySubscriptionModal', true);
};

export const closeKlaritySubscriptionModal = () => {
    setSubscriptionCallbackShowSuccess(false);
    GlobalLayerStore.set('showKlaritySubscriptionModal', false);
};

export const openKlarityPlanAdvertisingModal = (paySuccessPath?: string, callback?: (v?: any) => void) => {
    GlobalLayerStore.set('showKlarityPlanAdvertising', {
        show: true,
        callback,
        paySuccessPath,
    });
};

export const closeKlarityPlanAdvertisingModal = () => {
    GlobalLayerStore.set('showKlarityPlanAdvertising', {
        show: false,
    });
};

export const closeKiwiPlanAdvertisingModal = () => {
    setSubscriptionCallbackShowSuccess(false);
    GlobalLayerStore.set('showKiwiPlanAdvertisingModal', false);
};

export const openKiwiPlanAdvertisingModal = (showSuccessModal: boolean = true, path?: string) => {
    if (showSuccessModal) {
        setSubscriptionCallbackShowSuccess(true);
    }
    setShowKiwiPlanAdvertise(false);
    const callbackPath = path || getPath();
    setSubscriptionCallbackPath(callbackPath);
    //clear channel info
    setPendingSubscriptionChannel(undefined);
    GlobalLayerStore.set('pendingSubscriptionChannel', undefined);
    GlobalLayerStore.set('showKiwiPlanAdvertisingModal', true);
};

export const showBlackFriday2024EnhancementModal = () => {
    GlobalLayerStore.set('showBlackFriday2024EnhancementModal', true);
};

export const closeBlackFriday2024EnhancementModal = () => {
    GlobalLayerStore.set('showBlackFriday2024EnhancementModal', false);
};

export const showBlackFriday2024JoinCampaignModal = () => {
    GlobalLayerStore.set('showBlackFriday2024JoinCampaignModal', true);
};

export const closeBlackFriday2024JoinCampaignModal = () => {
    GlobalLayerStore.set('showBlackFriday2024JoinCampaignModal', false);
};

export const showBlackFriday2024LeaveCampaignModal = () => {
    GlobalLayerStore.set('showBlackFriday2024LeaveCampaignModal', true);
};

export const closeBlackFriday2024LeaveCampaignModal = () => {
    GlobalLayerStore.set('showBlackFriday2024LeaveCampaignModal', false);
};

export const showTermsNConditionsModal = () => {
    GlobalLayerStore.set('showTermsNConditionsModal', true);
};

export const closeTermsNConditionsModal = () => {
    GlobalLayerStore.set('showTermsNConditionsModal', false);
};

export const showCCCTermsNConditionsModal = () => {
    GlobalLayerStore.set('showCCCTermsNConditionsModal', true);
};

export const closeCCCTermsNConditionsModal = () => {
    GlobalLayerStore.set('showCCCTermsNConditionsModal', false);
};

/* Campaign Modal Template start */

export const showCampaignModal = () => {
    GlobalLayerStore.set('showCampaignModal', true);
};

export const closeCampaignModal = () => {
    GlobalLayerStore.set('showCampaignModal', false);
};

export const showLeaveCampaignModal = () => {
    GlobalLayerStore.set('showLeaveCampaignModal', true);
};

export const closeLeaveCampaignModal = () => {
    GlobalLayerStore.set('showLeaveCampaignModal', false);
};

export const showCampaignTermsNConditionsModal = () => {
    GlobalLayerStore.set('showCampaignTermsNConditionsModal', true);
};

export const closeCampaignTermsNConditionsModal = () => {
    GlobalLayerStore.set('showCampaignTermsNConditionsModal', false);
};

/* Campaign Modal Template end */

export const openTextVisitUnSubmittedDrawer = (
    textVisitUuid: string,
    onSave?: () => void | boolean,
    fullyWithSaveFun?: boolean,
    overrideProviderId?: number | string,
    readOnly?: boolean,
) => {
    GlobalLayerStore.set('showTextVisitUnSubmittedDrawer', {
        show: true,
        textVisitUuid,
        onSave,
        fullyWithSaveFun,
        overrideProviderId,
        readOnly,
    });
};

export const closeTextVisitUnSubmittedDrawer = () => {
    GlobalLayerStore.set('showTextVisitUnSubmittedDrawer', {
        show: false,
        textVisitUuid: undefined,
        onSave: undefined,
    });
};

export const openTextVisitSubmittedDrawer = (textVisitUuid: string, overrideProviderId?: number | string) => {
    GlobalLayerStore.set('showTextVisitSubmittedDrawer', {
        show: true,
        textVisitUuid,
        overrideProviderId,
    });
};

export const closeTextVisitSubmittedDrawer = () => {
    GlobalLayerStore.set('showTextVisitSubmittedDrawer', {
        show: false,
        textVisitUuid: undefined,
    });
};

export const openVideoVisitSubmittedDrawer = (appointmentId: number) => {
    GlobalLayerStore.set('showVideoVisitSubmittedDrawer', {
        show: true,
        appointmentId,
    });
};

export const closeVideoVisitSubmittedDrawer = () => {
    GlobalLayerStore.set('showVideoVisitSubmittedDrawer', {
        show: false,
        appointmentId: undefined,
    });
};

export const openNonAppointmentSubmittedDrawer = (noteId: number) => {
    GlobalLayerStore.set('showNonAppointmentSubmittedDrawer', {
        show: true,
        noteId,
    });
};

export const closeNonAppointmentSubmittedDrawer = () => {
    GlobalLayerStore.set('showNonAppointmentSubmittedDrawer', {
        show: false,
        noteId: undefined,
    });
};

export const openVideoVisitUnSubmittedDrawer = (appointmentId: number, onSave?: () => void) => {
    GlobalLayerStore.set('showVideoVisitUnSubmittedDrawer', {
        show: true,
        appointmentId,
        onSave,
    });
};

export const closeVideoVisitUnSubmittedDrawer = () => {
    GlobalLayerStore.set('showVideoVisitUnSubmittedDrawer', {
        show: false,
        appointmentId: undefined,
        onSave: undefined,
    });
};
